import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    successCheckDomain: false,
    errorCheckDomain: [],
    successGetDomain: false,
    updateStatusWitting: false,
    successUpdateStatus: false,
    error: '',
    domain: [],
    getDomainGuidScriptPending: false,
    successGetDomainGuidScript: false,
    errorGetDomainGuidScript: false,
    successAddDomain: null,
    isUniqe: null,
    waitingUpdateDomain: false,
    successUpdateDomain: null,
    errorUpdateDomain: ''

}

const domainReducer = (state = initialState, { type, action, error }) => {
    switch (type) {


        case types.GET_DOMAIN_REQUEST: {
            return {
                ...state,
                getDomainsWaiting: true,
                success: false,
                // domain: [],
                successGetDomain: false

            }
        }
        case types.GET_DOMAIN_SUCCESS: {

            return {
                ...state,
                getDomainsWaiting: false,
                domain: action.data,
                successGetDomain: true
            }
        }
        case types.GET_DOMAIN_ERROR: {

            return {
                ...state,
                getDomainsWaiting: false,
                error: error,
            }
        }

        case types.ADD_DOMAIN_REQUEST: {
            return {
                ...state,
                waiting: true,
                successAddDomain: null,
                successCheckDomain: false,
                error: ''
            }
        }
        case types.ADD_DOMAIN_SUCCESS: {
            return {
                ...state,
                waiting: false,
                successAddDomain: action.data,
            }
        }
        case types.ADD_DOMAIN_ERROR: {

            return {
                ...state,
                waiting: false,
                error: 'error',
            }
        }



        case types.UPDATE_DOMAIN_REQUEST: {
            return {
                ...state,
                waitingUpdateDomain: true,
                successUpdateDomain: null,
                errorUpdateDomain: ''
            }
        }
        case types.UPDATE_DOMAIN_SUCCESS: {
            return {
                ...state,
                waitingUpdateDomain: false,
                succesUpdateDomain: action.data,
            }
        }
        case types.UPDATE_DOMAIN_ERROR: {

            return {
                ...state,
                waitingUpdateDomain: false,
                errorUpdateDomain: 'error',
            }
        }



        case types.DELETE_DOMAIN_REQUEST: {
            return {
                ...state,
                waiting: true,
                success: false,
                error: ''
            }
        }
        case types.DELETE_DOMAIN_SUCCESS: {

            return {
                ...state,
                waiting: false,
                success: true,
            }
        }
        case types.DELETE_DOMAIN_ERROR: {
            return {
                ...state,
                waiting: false,
                error: error.error,
            }
        }

        case types.CHECK_DOMAIN_REQUEST: {
            return {
                ...state,
                waiting: true,
                successCheckDomain: false,
                errorCheckDomain: '',
                isUniqe: null
            }
        }
        case types.CHECK_DOMAIN_SUCCESS: {
            return {
                ...state,
                waiting: false,
                successCheckDomain: true,
                isUniqe: action.data
            }
        }
        case types.CHECK_DOMAIN_ERROR: {
            return {
                ...state,
                waiting: false,
                errorCheckDomain: error.data?.errors?.domainAddress,
            }
        }


        case types.UPDATE_STATUS_DOMAIN_REQUEST: {
            return {
                ...state,
                updateStatusWitting: true,
                successUpdateStatus: false,
            }
        }
        case types.UPDATE_STATUS_DOMAIN_SUCCESS: {

            return {
                ...state,
                updateStatusWitting: false,
                successUpdateStatus: true,
            }
        }
        case types.UPDATE_STATUS_DOMAIN_ERROR: {

            return {
                ...state,
                deactivateWitting: false,
            }
        }


        case types.GET_DOMAIN_GUID_SCRIPT_REQUEST: {
            return {
                ...state,
                getDomainGuidScriptPending: true,
                successGetDomainGuidScript: false,
                errorGetDomainGuidScript: false,

            }
        }
        case types.GET_DOMAIN_GUID_SCRIPT_SUCCESS: {

            return {
                ...state,
                getDomainGuidScriptPending: false,
                successGetDomainGuidScript: true,
                guidScript: action.data
            }
        }
        case types.GET_DOMAIN_GUID_SCRIPT_ERROR: {

            return {
                ...state,
                errorGetDomainGuidScript: true,
            }
        }




        case types.DOMAIN_RESET_PROPS: {
            return {
                ...state,
                getDomainsWaiting: false,
                waiting: false,
                success: false,
                successCheckDomain: false,
                successGetDomain: false,
                errorCheckDomain: [],
                error: '',
                updateStatusWitting: false,
                successUpdateStatus: false,
                getDomainGuidScriptPending: false,
                successGetDomainGuidScript: false,
                errorGetDomainGuidScript: false,
                successAddDomain: null,
                isUniqe: null,
                waitingUpdateDomain: false,
                successUpdateDomain: null,
                errorUpdateDomain: ''
            }
        }
        default:
            return state
    }
}

export default domainReducer;